<template>
  <input-base
    :overlap="overlap"
    :small="small"
    :transparent="transparent"
    :stretched="stretched"
    :slimmer="slimmer">

    <label slot="label">

      <q-icon
        :allowSelfUpdate="false"
        class="label-icon d-box d-md-none"
        width="11.5px"
        name="calendar" />

      <label
        v-if="!!inputLabel"
        :for="inputName">

        {{ inputLabel }}
      </label>
    </label>

    <div
      class="icon-input"
      slot="input">

      <q-icon
        :allowSelfUpdate="false"
        :class="getIconClass"
        width="16px"
        name="calendar" />

      <datetime
        :class="`${getInnerStyle} ${getExtraStyle}`"
        type="datetime"
        :locale="getLocale"
        v-model="dtime"
        ref="datetimePicker"
        :name="inputName"
        :format="dtimeFormat"
        :placeholder="inputPlaceholder"
        :min-datetime="getMinDateTime" />

    </div>

  </input-base>
</template>

<script>
import Datetime from '@/components/standard/input/vue-datetime/Datetime'
import '@/components/standard/input/vue-datetime/dist/vue-datetime.css'


import InputBase from '@/components/standard/input/InputBase'
import stylers from '@/mixins/components/standard/input/inputButton/stylers'
import '@/assets/styles/standardInputs.css'
import configurations from '@/assets/configurations/configurations'
import QIcon from '@/components/standard/display/QIcon'

import moment from 'moment'

export default {
  data () {
    return {
      dtimeFormat: configurations.dateTimePickerFormat,
      dtime: this.inputValue,
    }
  },

  computed: {
    /**
     * Gives current locale
     * @returns {String}
     */
    getLocale () {
      return this.$locale.current().split('_')[0] || 'sl'
    },
    /**
     * Gives icon's class
     * @returns {String}
     */
    getIconClass () {
      let base = `dtime-icon d-none d-md-block`
      if (this.small) base += ` adjust-small`
      if (this.smaller) base += ` adjust-smaller`
      return base
    },

    /**
     * GIves extra styles to datetime input
     * @returns {String}
     */
    getExtraStyle () {
      let base = ``
      if (this.boldPholder) base += ' dt-bold'
      return base.trim()
    },

    getInputValue () {
      return this.dtime
    },

    getMinDateTime () {
      return this.minDateTime
    }
  },

  components: {
    'q-icon': QIcon,
    'input-base': InputBase,
    'datetime': Datetime
  },

  mixins: [
    stylers
  ],

  watch: {
    dtime (newVal, oldVal) {
      this.sendUpdate()
    },

    inputValue (newVal) {
      this.dtime = newVal
    }
  },

  props: {
    inputValue: {
      required: false,
      default: ''
    },
    boldPholder: {
      type: Boolean,
      required: false,
      default: false
    },
    minDateTime: {
      type: String,
      required: false,
      default: null
    }
  }
}

</script>

<style>
.dt-bold .vdatetime-input {
  font-weight: bold;
}

.label-icon {
  top: -1px;
  position: relative;
}

.dtime-icon {
  position: absolute;
  margin-top: 15px;
  margin-left: 18px;
}
.dt-scroller {
  overflow: hidden;
}
.vdatetime-input {
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  padding-left: 31px;
}

@media (max-width: 768px) {
  .vdatetime-input {
    padding-left: 0;
    width: 168px;
  }
}
</style>

<style scoped>
.dt-picker {
  border: 1px solid rgb(194, 194, 194);
  padding: 5px 15px;
}
.rounded {
  border-radius: 10px;
}

.p-holder {
  position: absolute;
  margin-top: auto;
  font-size: 14px;
  transition: margin-top .3s, font-size .3s;
}
.above {
  margin-top: -15px;
  font-size: 10px;
}
.small {
  padding-top: 1px!important;
  padding-bottom: 1px!important;
  height: 27px!important;
}
.smaller {
  padding-top: 4px!important;
  padding-bottom: 4px!important;
  height: 32px!important;
}
.dtime-icon.adjust-small {
  margin-top: 4px;
}

.adjust-smaller {
  margin-top: 8px;
  margin-left: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/input/InputDateTime.vue?f804ae82